// extracted by mini-css-extract-plugin
module.exports = {"setStoreAndAddToCartBtn":"az_iRc"};